<template>
  <pure-outcome-screen v-if="outcome" :outcome="outcome"></pure-outcome-screen>
</template>

<script>
import PureOutcomeScreen from '@/views/PureOutcomeScreen'

export default {
  name: 'outcome-screen',
  components: { PureOutcomeScreen },
  computed: {
    outcome() {
      let outcomeName = this.$store.getters.getOutcome
      const outcomes = this.$store.state.outcomes
      let result = outcomes.filter(
        theOutcome => theOutcome.name === outcomeName
      )
      if (result.length > 0) {
        let temp = result[0]
        return {
          titleText: temp.content.product.titleText,
          buttonUrl: temp.content.product.buttonUrl,
          buttonText: temp.content.product.buttonText,
          productImageUrl: temp.content.product.productImageUrl,
          outcomeDescription: temp.content.product.outcomeDescription,
          introDescription:
            typeof temp.content.product.introDescription === 'string'
              ? temp.content.product.introDescription
              : null
        }
      } else {
        return false
      }
    }
  }
}
</script>
